require('./virtualMachinesWidget.style.scss');

class VirtualMachinesWidgetController {
    constructor($rootScope, dashboardService, sharedPersistenceService) {
        this.$rootScope = $rootScope;
        this.dashboardService = dashboardService;
        this.ENDPOINT = sharedPersistenceService.getRestEndpoints().VMS_REST;
        this.data = { totalCount: 0, protectedCount: 0, unProtectedCount: 0 };
        this.renderCounter = 0;
    }

    $onInit() {
        this.updateData();

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.updateData();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    updateData() {
        if (!this.widgetData) return;
        this.data = this.widgetData;
        this.renderCounter++;
    }
}

VirtualMachinesWidgetController.$inject = ['$rootScope', 'dashboardService', 'sharedPersistenceService'];

const virtualMachinesWidgetComponent = {
    controller: VirtualMachinesWidgetController,
    template: require('./virtualMachinesWidget.template.html'),
    bindings: { widgetData: '<' },
};

module.exports = virtualMachinesWidgetComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/virtualMachinesWidget/virtualMachinesWidget.component.js